import React from "react";
import styles from "./switcher_tel_list.module.css";

function SwitcherTelList({
  checkTelList, handleCheckTelList
}) {

  return (
    <div className={`${styles.checkbox}`}>
    <input
      id="cb_tel"
      className={`${styles.button}`}
      type="checkbox"
      checked={checkTelList}
      onChange={handleCheckTelList}
    />
    <label htmlFor="cb_tel" className={`${styles.label}`}>
    </label>
  </div>
  );
}

export default SwitcherTelList;
